import React, { useState, useEffect } from 'react';
import ContentFileUpload from '../../../../../../component-controller-mod/component-serv/card-fs-cp/upload-card-op/ts/contentFileUpload';
import { LabelRow } from './primitives';

interface ImageUploadFieldProps {
  label:         string;
  currentSrc?:   string;
  currentName?:  string;
  defaultName?:  string;
  onFile:        (f: File) => void | Promise<string | undefined>;
  onMediaClick?: () => void;
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  label, currentSrc, currentName, defaultName, onFile, onMediaClick,
}) => {
  const [previewSrc,  setPreviewSrc]  = useState<string | undefined>(currentSrc);
  const [previewName, setPreviewName] = useState<string>(
    currentName || defaultName || 'No file selected'
  );
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setPreviewSrc(currentSrc);
    if (currentName) {
      setPreviewName(currentName);
    } else if (currentSrc) {
      try {
        const url  = new URL(currentSrc);
        const name = url.pathname.split('/').pop() ?? currentSrc;
        setPreviewName(name);
      } catch {
        const name = currentSrc.split('/').pop()?.split('?')[0] ?? currentSrc;
        setPreviewName(name);
      }
    } else {
      setPreviewName(defaultName || 'No file selected');
    }
  }, [currentSrc, currentName, defaultName]);

  const handleFilesSelected = async (files: File[]) => {
    const file = files[0];
    if (!file) return;
    setPreviewName(file.name);
    setIsUploading(true);
    try {
      const result = onFile(file);
      if (result instanceof Promise) {
        const uploadedUrl = await result;
        if (uploadedUrl) {
          setPreviewSrc(uploadedUrl);
          setPreviewName(file.name);
        }
      }
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="scl--cms-content-edit-company-upload-block">
      <LabelRow label={label} />
      <div className="scl--cms-content-edit-company-upload-row">
        <div className="scl--cms-content-edit-company-upload-preview">
          <div className="scl--cms-content-edit-company-upload-preview-inner">
            <div className="scl--cms-content-edit-company-upload-thumb">
              {isUploading ? (
                <span className="scl--cms-content-edit-company-upload-loading">Uploading…</span>
              ) : previewSrc && (
                <img
                  key={previewSrc}
                  src={previewSrc}
                  alt={previewName}
                  onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
                />
              )}
            </div>
            <div className="scl--cms-content-edit-company-upload-meta">
              <span className="scl--cms-content-edit-company-upload-name">
                {isUploading ? 'Uploading…' : previewName}
              </span>
            </div>
          </div>
        </div>
        <div className="scl--cms-content-edit-company-upload-zone-wrap">
          <ContentFileUpload
            accept=".jpg,.jpeg,.png,.svg"
            supportText="JPG, PNG or SVG"
            onFilesSelected={handleFilesSelected}
            onMediaClick={onMediaClick}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageUploadField;